import React from 'react';
import { useUsersList } from './useUsersList';
import { UsersList } from './UsersList';

export const Users = () => {
  const data = useUsersList();
  return <UsersList data={data} />;
}
